import React from "react";
import { Link } from "react-router-dom";

export const ArrayToCommaSaperatorColumnFormatter = (values) => {
     console.log('values----------->:', values)
    let str = ''
    if (values.length > 0) {
  
      values.map((valC, ind) => {
        console.log(valC)
        if (ind == 0) {
          str = valC
        } else {
          str = str + ", " + valC
        }
      })
    } else {
      str = "-"
    }
    return str;
    // return `${IMAGE_URL}/${value}`;
  }
  export const ArrayToCommaSaperatorColumnFormatter2 = (values) => {
    console.log('values----------->:', values)
   let str = ''
   if (values.length > 0) {
 
     values.map((valC, ind) => {
        console.log(valC)
       if (ind == 0) {
         str = valC.name
       } else {
         str = str + ", " + valC.name
       }
     })
   } else {
     str = "-"
   }
   return str;
   // return `${IMAGE_URL}/${value}`;
 }
